var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClients = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  clipPath: "url(#Clients_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.321 5.164c0 1.431-1.115 2.588-2.496 2.588s-2.497-1.157-2.497-2.588V3.682c0-1.431 1.115-2.588 2.497-2.588s2.496 1.157 2.496 2.588zM6.166 5.671a2.08 2.08 0 1 0 0-4.16 2.08 2.08 0 0 0 0 4.16M8.264 10.365a4.95 4.95 0 0 0-2.93-.949 5 5 0 0 0-4.901 4.037c-.1.5.316.957.824.957h4.078M12.825 10.248a6.66 6.66 0 0 0-6.591 5.71c-.075.498.324.948.832.948h11.518a.84.84 0 0 0 .832-.949 6.66 6.66 0 0 0-6.591-5.709"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Clients_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .678h19.84v16.644H0z"
})))));
export default SvgClients;